import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { KEYWORD_CACHE_KEYS } from "./keys";

import { UpdateKeyword } from "@/types/keyword";
import { KeywordRepository } from "@/repositories/keyword";

export const useUpdateKeyword = () => {
  const keywordRepository = useRef(new KeywordRepository());
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateKeyword) => {
      return keywordRepository.current.update(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [KEYWORD_CACHE_KEYS.LIST, {}],
      });
    },
  });
};
